import CategoryPage from '../components/CategoryPage';

export default function Movies() {
  return <CategoryPage type="movie" title="Movies" />;
}
